import Head from "next/head";

type Props = {
  linkurl: String,
}

const Link = ({linkurl}: Props) => {
  return (
    <>
      <Head>
        <title>Sellon | Home</title>
        
        {/* iOS meta tags & icons */}
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black" />
        <meta name="apple-mobile-web-app-title" content="SELLON" />
        <meta name="apple-itunes-app" content={"app-id=1462394563, app-argument="+linkurl} />
        <meta name="google-signin-client_id" content="287561416073-mk7it678n3b5nm5pv1rhn2fu4abgah7j.apps.googleusercontent.com" />
        <meta name="google-site-verification" content="dn5I4cXleHps1SObDmo-lhFFfNPJ02DHdMWMfWwVWJk" />
      </Head>
      
      <div className="bg-white touch-pan-y h-auto">
        <div className="flex justify-center items-center ml-10 mr-10 bg-white">
          <img src={'/media/hero/image_download.png'} className="w-screen" alt="" />
        </div>
      </div>
    </>
  );
}

export default Link;